import { fetchEndpoint } from '../server/network';

//登录
export function getLogin(params) {
  return fetchEndpoint(
    '/login',
    'POST',
    params
  )
}

//店铺列表
export function getShopList(params) {
  return fetchEndpoint(
    '/login/shop',
    'GET',
  )
}

//多语言列表
export function getLanguageList(params) {
  return fetchEndpoint(
    '/language',
    'GET',
  )
}

//地址列表
export function getregionsList(params) {
  return fetchEndpoint(
    '/region/' + params.id,
    'GET',
  )
}

//区号列表
export function getAreacode(params) {
  return fetchEndpoint(
    '/areacode',
    'GET',
  )
}

//音乐列表
export function getMusicList(params) {
  return fetchEndpoint(
    '/music',
    'GET',
  )
}



